(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Treetable", [], factory);
	else if(typeof exports === 'object')
		exports["Treetable"] = factory();
	else
		root["Treetable"] = factory();
})(this, function() {
return 